import React, { createContext, useContext } from 'react'
import {
  IInsightsV1Statistics,
  IInsightsV1FavoriteStatistics,
} from '../../shared/types'

type Setter = <T>(newValue?: T) => void
export interface ContextState {
  filters: {
    key: string
    value: string
    label: string
  }[]
  setFilters: Setter
  datePickerState: any
  advertisers: {
    advertiserUuid: string
    advertiserDomain: string
  }[]
  channels: {
    channelUuid: string
    channelName: string
    channelDomain: string
    channelFaviconUrl: string
    channelType: string
  }[]
  networks: {
    networkUuid: string
    networkName: string
    networkLogoUrl: string
  }[]
  users: {
    userUuid: string
    userFirstname: string
    userLastname: string
  }[]
  assignees: {
    assigneeAdvertiserUuid: string
    assigneeAdvertiserDomain: string
    assigneeUserFirstname: string
    assigneeUserLastname: string
  }[]
  statuses: {
    advertiserStatusAdvertiserUuid: string
    advertiserStatusAdvertiserDomain: string
    advertiserStatusType: string
    advertiserStatusValue: string
  }[]
  adsStats: {
    domain: string
    countryCode: string
    currencyCode: string
    revenue: number
    cost: number
    clicks: number
    conversions: number
  }[]
  setAssignees: Setter
  search: string
  setSearch: Setter
  data: IInsightsV1Statistics
  prevData: IInsightsV1Statistics
  totalCount: number
  setTotalCount: Setter
  favorites: IInsightsV1FavoriteStatistics[]
  setFavorites: Setter
  refreshFavorites: Setter
  group: string
  setGroup: Setter
  columns: string[]
  setColumns: Setter
  availableColumns: string[]
  crFilter: boolean
  setCrFilter: Setter
  ecrFilter: boolean
  setEcrFilter: Setter
  favFilter: boolean
  setFavFilter: Setter
  clickFilter: boolean
  setClickFilter: Setter
  trafficFilter: boolean
  setTrafficFilter: Setter
  showGraph: boolean
  setShowGraph: Setter
  graphHeight: number
  setGraphHeight: Setter
  graphColumns: string[]
  setGraphColumns: Setter
  currencyCode: string
  setSelectedGroupByTime: Setter
  selectedGroupByTime: string
}

export const statisticsContext = createContext({})

export const useStatistics = (): ContextState =>
  useContext(statisticsContext) as ContextState

export const StatisticsContextProvider = statisticsContext.Provider
